// @TODO: this is migrated version of src/js/common/filters/displayName.filter.js | (src/app/common/pipes/display-name.pipe.ts)
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'subjectDisplayName'
})
export class SubjectDisplayNamePipe implements PipeTransform {
    transform(subject: any, withId?: boolean): string {
        if (!subject || !subject.opsubType) {
            return ''
        }

        let name = ''
        let ident = ''

        if (['OFO', 'FO'].includes(subject.opsubType)) {
            const words = [subject.prijmeni, subject.jmeno].filter(Boolean)
            name = words.join(' ')

            const titles = [subject.titulPredJmenem, subject.titulZaJmenem].filter(Boolean)
            if (titles.length) {
                name += ', ' + titles.join(' ')
            }

            if (subject.opsubType === 'OFO' && subject.rodneCislo) {
                ident = 'RČ ' + subject.rodneCislo
            } else if (subject.ico) {
                ident = 'IČ ' + subject.ico
            }
        } else if (subject.opsubType === 'SJM') {
            name = 'SJM' + (subject.nazev ? ' ' + subject.nazev : '')
        } else {
            name = subject.nazev || ''
            if (subject.ico) {
                ident = 'IČ ' + subject.ico
            }
        }

        name = name || '—'

        return withId && ident ? `${name} (${ident})` : name
    }
}
